import * as Api from '@ViewModels';
import * as React from 'react';
import {
	Dropdown,
	DropdownCheckboxItem,
	DropdownContent,
	DropdownItem,
	DropdownSelectTrigger,
	DropdownSeparator,
} from '../../../../components-v2/Dropdown';
import { styleSheet } from './styles';

interface IMeetingStatusOption {
	value: Api.MeetingStatus;
	label: string;
}

const MEETING_STATUS_OPTIONS: IMeetingStatusOption[] = [
	{ value: Api.MeetingStatus.Scheduled, label: 'Scheduled' },
	{ value: Api.MeetingStatus.Cancelled, label: 'Cancelled' },
	{ value: Api.MeetingStatus.WaitingForDisposition, label: 'Scheduled (Past)' },
];

export const MeetingStatusFilterDropdown = ({
	selectedStatuses,
	setSelectedStatuses,
	anchorClassName: _anchorClassName,
}: {
	selectedStatuses: Api.MeetingStatus[];
	setSelectedStatuses: React.Dispatch<React.SetStateAction<Api.MeetingStatus[]>>;
	/** @deprecated No longer used with v2 Dropdown. Kept for API compatibility. */
	anchorClassName?: string;
}) => {
	const dropdownMessage = React.useMemo(() => {
		if (selectedStatuses.length === 0) {
			return 'Status';
		}
		const firstLabel = MEETING_STATUS_OPTIONS.find(o => o.value === selectedStatuses[0])?.label ?? selectedStatuses[0];
		return selectedStatuses.length === 1 ? firstLabel : `${firstLabel} +${selectedStatuses.length - 1}`;
	}, [selectedStatuses]);

	const resetFilter = () => {
		setSelectedStatuses([]);
	};

	const isStatusSelected = (status: Api.MeetingStatus) => {
		return selectedStatuses.includes(status);
	};

	const onToggleStatus = (status: Api.MeetingStatus) => {
		const isSelected = isStatusSelected(status);

		if (isSelected) {
			setSelectedStatuses(selectedStatuses.filter(s => s !== status));
		} else {
			setSelectedStatuses([...selectedStatuses, status]);
		}
	};

	return (
		<Dropdown>
			<DropdownSelectTrigger styles={[styleSheet.trigger]}>{dropdownMessage}</DropdownSelectTrigger>
			<DropdownContent align='start' styles={[styleSheet.content]}>
				{MEETING_STATUS_OPTIONS.map(option => (
					<DropdownCheckboxItem
						key={`status-select-${option.value}`}
						checked={isStatusSelected(option.value)}
						onCheckedChange={() => onToggleStatus(option.value)}
						closeOnClick={false}
					>
						{option.label}
					</DropdownCheckboxItem>
				))}
				<DropdownSeparator />
				<DropdownItem onClick={resetFilter} styles={[styleSheet.resetItem]}>
					Reset Filter
				</DropdownItem>
			</DropdownContent>
		</Dropdown>
	);
};
